import { useTranslations } from "next-intl";
import { useState } from "react";
import IconFont from '@/components/ui/iconFont';
import { getFaqList } from "./utils";
import { showDepositFaqModal } from "./modal";
import { track } from '@/utils/track';

export interface DepositFaqProps {
  itemClz?: string;
  type?: string;
  onlyShowTitle?: boolean;
}

function getTrackCurrentPage(type?: string) {
  if (type === 'deposit') return 'deposit details';
  if (type === 'withdraw') return 'withdraw details';
  return undefined;
}

export default function DepositFaq({ itemClz = '', type, onlyShowTitle }: DepositFaqProps) {
  const t = useTranslations('footer');
  const [expandedItems, setExpandedItems] = useState<Set<number>>(new Set([]));
  const features = getFaqList(t, type);
  const list = [
    {
      title: t('faq.title'),
      description: <div className="flex flex-col flex-wrap items-start gap-[20px] leading-[16px] font-medium text-tertiary text-ss">
        {
          features.map((item) => {
            return (
              <span
                key={item.key}
                className="text-[#748094] text-[11px] font-medium active:scale-90"
                onClick={() => handleItemClick(item.key)}>
                {item.title}
              </span>
            );
          })
        }
      </div>,
    }
  ];

  const toggleExpanded = (index: number) => {
    setExpandedItems(prev => {
      const newSet = new Set(prev);
      if (newSet.has(index)) {
        newSet.delete(index);
      } else {
        newSet.add(index);
      }
      return newSet;
    });
  };

  const handleTitleClick = () => {
    track('recharge_withdraw_faq_click', { current_page: getTrackCurrentPage(type) });
    showDepositFaqModal({ type });
  };

  const handleItemClick = (key: string) => {
    track('recharge_withdraw_faq_click', { current_page: getTrackCurrentPage(type) });
    showDepositFaqModal({ itemKey: key, type });
  };

  if (onlyShowTitle) {
    return <div className="w-full bg-[#181D29] overflow-hidden rounded-[10px]">
      <div
        className="h-[43px] flex justify-between items-center px-[15px] active:scale-90"
        onClick={handleTitleClick}
      >
        <span className="text-[#fff] text-[12px] font-medium leading-[10px]">{list[0].title}</span>
        <IconFont name="arrow-right" size={10} color="#a9b5cb" />
      </div>
    </div>;
  }

  return (<div className="w-full">
    {
      list.map((item, index) => {
        const isExpanded = expandedItems.has(index);
        return (
          <div key={index} className={`flex flex-col pt-[19.5px] px-[12px] ${itemClz}`}>
            <div className="mb-[23px]">
              {
                item.title && (
                  <>
                    <div
                      className="flex justify-between items-center w-full cursor-pointer"
                      onClick={() => toggleExpanded(index)}
                    >
                      <span className="text-secondary text-xs font-medium leading-[10px]">{item.title}</span>
                      <IconFont name="arrow-up" size={10} color="#a9b5cb" className={`mt-[4px] mr-[15px] transition-transform duration-200 ${!isExpanded ? 'rotate-180' : ''
                        }`} />
                    </div>
                  </>
                )
              }
              {isExpanded && (
                <div className="text-tertiary text-xss leading-[10px] mt-[24px] font-medium">
                  {item.description}
                </div>
              )}

            </div>
            {index === list.length - 1 && <div className="bg-[rgba(214,234,255,0.06)] w-full h-[1px] px-[12px]" />}
          </div>
        );
      })
    }
  </div>);
}
